import { AxiosResponse } from "axios";
import { apisiseci } from "./api";
import { SearchTermParam } from "./api-tansquery/get-list-cities";
import { CityResponse } from "../@types/cities";

export const fetchCidadesBySearchTerm = (
  params: SearchTermParam
): Promise<AxiosResponse<CityResponse>> =>
  apisiseci.get(`/cms/cidades/`, {
    params,
  });
